module.exports = __webpack_public_path__ + "img/jtexpress_charge_logo.d1e03152.png";